<!-- KUN GAPFUND (man kan aldrig lande på denne kvitteringsside med andet end gapfund) -->
<div *ngIf="orders != null" [ngClass]="{ 'active': finalized }">
    <div class="receipt-basket" #receiptPaper id="receipt-paper">
        <ng-container *ngIf="orders">
            <div class='receipt__section'>
                <div class="receipt__row  receipt__row">
                    <div class="dark-text" *ngIf="gapfundDeclined">
                        {{paymentPeriod === 1 ? "Månedlig" : "Halvårlig" }} betaling fra {{ nextDrawDate | date : "MMMM" }}
                    </div>
                    <div class="dark-text" *ngIf="!gapfundDeclined">
                        Engangsbetaling for {{ nextDrawDate | date : "MMMM" }}
                    </div>
                    <div class="receipt__row-price">
                        <strong>
                            {{ totalPrice | money }}<span *ngIf="gapfundDeclined">{{ paymentPeriod === 6 ? "/halvår" : "/md" }}</span>
                        </strong>
                        <span class="accordion__toggle {{accordionIsOpen ? 'accordion__toggle--open' : ''}}"
                            (click)="toggleAccordion()"></span>
                    </div>
                </div>
            </div>
            <div class="receipt__section accordion__content {{accordionIsOpen ? 'accordion__content--open' : ''}}">
                <div class="orderline accordion">
                    <div *ngFor="let orderedPackage of orderedPackages">
                        <div class="order__row">
                            <div
                                class='order__icon order__icon--{{ ("global_package_primary_name_" + orderedPackage.packageInstance.TicketPackage.Name) | resource }}'>
                            </div>
                            <div class="order__type">
                                <div class="order__name">{{ orderedPackage.packageInstance.TicketPackage.Name }}
                                </div>
                                <div class="order__tickets"
                                    *ngFor="let share of orderedPackage.packageInstance.Shares">
                                    <div class="order__ticket">
                                        {{ share.Type.Name | typename }} - lodnr. {{ share.Ticket.TicketNumber }}{{ share.Name }}
                                    </div>
                                </div>
                            </div>
                            <div class="order__price" *ngIf="gapfundDeclined">
                              {{ (paymentPeriod === 6 ? orderedPackage.price*6 : orderedPackage.price) | money }}<span>{{ paymentPeriod === 6 ? "/halvår" : "/md" }}</span>
                            </div>
                            <div class="order__price" *ngIf="!gapfundDeclined">
                              {{ orderedPackage.price | money }}
                            </div>
                        </div>
                    </div>

                    <div *ngFor="let orderedShare of orderedShares">
                        <div class="order__row">
                            <div
                                class='order__icon order__icon--{{ ("global_ticket_normalized_name_" + orderedShare.share.Type.Size) | resource }}'>
                            </div>
                            <div class="order__type">
                                <div class="order__name">{{ ('global_share_type_name_' +
                                    orderedShare.share.Type.Name) | resource }}</div>
                                <div class="order__ticket">
                                    {{ orderedShare.share.Type.Name | typename }} - lodnr. {{
                                    orderedShare.share.Ticket.TicketNumber }}{{ orderedShare.share.Name }}
                                </div>
                            </div>
                            <div class="order__price" *ngIf="gapfundDeclined">
                             {{ (paymentPeriod === 6 ? orderedShare.price*6 :
                                orderedShare.price) | money }}<span>{{ paymentPeriod === 6 ? "/halvår" : "/md" }}</span>
                            </div>
                            <div class="order__price" *ngIf="!gapfundDeclined">
                              {{ orderedShare.price | money }}
                            </div>
                        </div>
                    </div>

                    <div *ngIf="gapfundDeclined && !isCardPayment">
                        <div *ngFor="let fee of BSFees; let i = index" class="order-container">
                            <div class="order__row removable">
                                <div class="order-fee-icon">
                                </div>
                                <div class="order-container-info">
                                    <div class="">
                                        <div class="fee title">
                                            Betalingsgebyr
                                        </div>
                                    </div>
                                </div>
                                <div class="order-price">
                                    {{fee.value | money}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
